const WarningBanner = ({ paymentMethod }) => (
  <div className="warning-banner">
    <strong>{paymentMethod} </strong>is not available as a primary payment method at the moment. It is currently in beta testing and should be available on the platform in the future. Expect an update soon.
  </div>
);

export default WarningBanner;
